import { Component, ojs, app, v, payload } from "modular-openscriptjs";
import { monetary, formatThousand, either } from "../../../helpers";

const h = app("h");
const gc = app("gc");

export default class OrderProductView extends Component {
    render(item, order, ...args) {
        const product = item.versioned_buyable;
        if (!product) return h.empty();

        const userCurrency = gc.user?.currency || "KES";

        return h.div(
            { class: "p-3 border rounded-4 bg-white shadow-sm mb-3 position-relative" },
            h.div(
                { class: "d-flex align-items-start gap-3 flex-wrap flex-md-nowrap" },
                // Image or Placeholder
                either(
                    product.thumbnail || (product.images && product.images.length > 0),
                    () => h.img({
                        src: product.thumbnail || product.images[0]?.path,
                        class: "rounded-3 object-fit-cover border",
                        style: "width: 72px; height: 72px;"
                    }),
                    () => h.div(
                        {
                            class: "bg-light rounded-3 d-flex align-items-center justify-content-center text-secondary border border-light-subtle",
                            style: "width: 72px; height: 72px;"
                        },
                        h.i({ class: "bi bi-bag-heart fs-3" })
                    )
                ),

                // Info Section
                h.div(
                    { class: "flex-fill min-w-0" },
                    h.div({ class: "d-flex justify-content-between align-items-start" },
                        h.h6({ class: "fw-bold text-dark mb-1 text-truncate" }, product.name),
                        h.span({ class: "badge bg-info-subtle text-info border border-info-subtle rounded-pill fs-xsm px-2 py-1" }, "Custom Product")
                    ),
                    h.div({ class: "text-muted fs-xsm mb-2 text-truncate" }, product.description || "No description available."),
                    either(product.is_errand, () => h.span(
                        { class: "badge bg-danger-subtle text-danger border border-danger-subtle rounded-pill fs-xsm py-1 px-2" },
                        "Errand Task"
                    ))
                ),

                // Price and Status
                h.div(
                    { class: "d-flex flex-column align-items-md-end justify-content-between h-100 flex-shrink-0" },
                    h.div(
                        { class: "text-end mb-2" },
                        h.div({ class: "text-muted fs-xsm" }, "Total Price"),
                        h.div({ class: "fw-bold text-primary fs-5" }, monetary(item.price * item.quantity, userCurrency)),
                        h.small({ class: "text-muted fs-xsm" }, `${monetary(item.price, userCurrency)} x${item.quantity}`),
                        // A global/Carata-funded deal isn't shown here - the customer was
                        // still charged the normal price, and per business-side rules only
                        // the business's own deals are surfaced on this screen.
                        //
                        // item.price above already reflects this deal - for a
                        // business-funded deal it's reverse-bracketed from the
                        // discounted total (see OrderService::computeItemFinancials()),
                        // so the "Total Price" shown above is already the reduced
                        // amount. item.discounted_price is a different, larger
                        // bracket (full retail price including Carata's markup) and
                        // isn't a further discount on top of item.price, so it isn't
                        // shown here as a comparison.
                        either(item?.deal && item.deal.company_id !== null && item?.discounted_price != null, () => h.div(
                            { class: "text-muted fs-xsm" },
                            h.i({ class: "bi bi-tag-fill me-1 text-success" }),
                            `Deal: ${item.deal.name} applied`
                        )),
                        // Packaging (container) fee is already folded into the total price
                        // above, and it's never commissioned - call it out separately.
                        either(item?.package_price > 0, () => h.div(
                            { class: "text-muted fs-xsm" },
                            h.i({ class: "bi bi-box-seam me-1" }),
                            "Packaging Fee: ",
                            h.strong({ class: "text-dark" }, monetary(item.package_price * item.quantity, userCurrency)),
                            " (not commissioned)"
                        )),
                        either(item?.company_id, () => h.div(
                            { class: "text-muted fs-xsm" },
                            "Business Commission: ",
                            h.strong({ class: "text-dark" }, `${Math.ceil(item?.business_commission_rate ?? 0)}%`),
                            either(item?.business_commission > 0, () => h.span(
                                ` (${monetary(item.business_commission, userCurrency)})`
                            ))
                        ))
                    ),
                    // Item Status badge
                    h.span(
                        { class: `badge rounded-pill px-3 py-1 text-capitalize fs-xsm ${this.getStatusBadgeClass(item.status)}` },
                        item.status || "queued"
                    )
                )
            ),
            ...args
        );
    }

    getStatusBadgeClass(status) {
        switch (status) {
            case 'ready': return 'bg-success text-white';
            case 'processing': return 'bg-warning text-dark';
            case 'picked up': return 'bg-info text-white';
            default: return 'bg-secondary text-white';
        }
    }
}

ojs(OrderProductView);
